export function initResponsiveIframes() {
    // Responsive iframe handler for multiple iframes
    window.addEventListener("message", function (event) {
        if (event.data.type === "aspectRatio" && event.source) {
            // Find the specific iframe that sent the message
            const iframes = document.querySelectorAll(".responsive-iframe-container iframe");
            let targetContainer = null;

            iframes.forEach((iframe) => {
                if (iframe.contentWindow === event.source) {
                    targetContainer = iframe.closest(".responsive-iframe-container");
                }
            });

            if (targetContainer) {
                const paddingTop = (1 / event.data.ratio) * 100;
                const uniqueClass = "aspect-" + Math.random().toString(36).substr(2, 9);
                targetContainer.classList.add(uniqueClass);

                const style = document.createElement("style");
                style.textContent = `.${uniqueClass}::before { padding-top: ${paddingTop}% !important; }`;
                document.head.appendChild(style);
            }
        }
    });
}
